


// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Button,
//   useMediaQuery,
//   CircularProgress
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { useTabContext } from './TabContext';

// import BedIcon from '@mui/icons-material/Bed';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import ApartmentIcon from '@mui/icons-material/Apartment';

// const getAmenityIcon = (amenityType) => {
//   const amenityIconMap = {
//     'BHK': <BedIcon />,
//     'Floor': <ApartmentIcon />,
//     'Size': <SquareFootIcon />,
//     'Bathroom': <BathtubIcon />
//   };

//   return amenityIconMap[amenityType] || <SquareFootIcon />;
// };

// const FeaturedProperties = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const { activeTab } = useTabContext();

//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   const categoryMap = {
//     'Buy': 'sale',
//     'Rent': 'rent',
//     'Plot': 'plot',
//   };

//   useEffect(() => {
//     const fetchCommercialProperties = async () => {
//       try {
//         setLoading(true);
//         const categoryType = categoryMap[activeTab];
        
//         let url = 'https://www.propertydealstalk.com/api/property/filterProperties?property_type=commercial';
        
//         if (activeTab === 'Plot') {
//           url = 'https://www.propertydealstalk.com/api/property/filterProperties?property_type=commercial&asset_type=plot';
//         } else if (categoryType) {
//           url += `&category=${categoryType}`;
//         }

//         const response = await fetch(url);

//         if (!response.ok) {
//           throw new Error('Failed to fetch properties');
//         }

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           setProperties(data.result.properties);
//         } else {
//           throw new Error(data.message || 'Failed to fetch properties');
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCommercialProperties();
//   }, [activeTab]);

//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       return;
//     }

//     try {
//       const userId = userData.id;
//       if (!userId) {
//         return;
//       }

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();
//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully');
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   const formatPrice = (price) => {
//     if (!price || price === 0 || price === '0') return '';
    
//     const priceStr = price.toString();
//     const lastThree = priceStr.substring(priceStr.length - 3);
//     const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
    
//     return lastThree;
//   };

//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100;
//   };

//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   const handleViewAllClick = () => {
//     navigate('/featured-view');
//   };

//   const handleViewProperty = (propertyId) => {
//     recordPropertyView(propertyId);
//   };

//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   const getDisplayPrice = (property) => {
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
//         return property.monthly_rent;
//       }
//     }

//     if (isValidValue(property.asking_price) && property.asking_price !== 0) {
//       return property.asking_price;
//     }

//     return null;
//   };

//   const getPropertyAmenities = (property) => {
//     const amenities = [];

//     if (isValidValue(property.bhk)) {
//       amenities.push({ type: 'BHK', value: `${property.bhk} BHK` });
//     }

//     if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
//       amenities.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
//     }

//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push({ type: 'Size', value: `${property.property_size} ${sizeUnit}` });
//     }

//     return amenities;
//   };

//   const getSectionTitle = () => {
//     switch (activeTab) {
//       case 'Buy':
//         return 'Commercial Property Deals for Sale';
//       case 'Rent':
//         return 'Commercial Property Deals for Rent';
//       case 'Plot':
//         return 'Commercial Plot Deals';
//       default:
//         return 'Commercial Property Deals';
//     }
//   };

//   return (
//     <Box
//       id="featured-properties"
//       sx={{
//         backgroundColor: '#fff',
//         padding: '0 20px 40px',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '30px',
//         marginTop: '30px',
//         fontFamily: 'Outfit',
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           margin: '20px 0',
//           position: 'relative',
//         }}
//       >
//         <Box sx={{ width: '100%', textAlign: 'center' }}>
//           <Typography
//             sx={{
//               fontSize: '1.5rem',
//               fontWeight: 600,
//               position: 'absolute',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               width: 'auto',
//             }}
//           >
//             {getSectionTitle()}
//           </Typography>
//         </Box>
//         <Button
//           onClick={handleViewAllClick}
//           variant="text"
//           sx={{
//             color: '#626262',
//             fontSize: '0.8rem',
//             fontWeight: 500,
//             zIndex: 1,
//             marginLeft: 'auto',
//           }}
//         >
//           View All
//         </Button>
//       </Box>

//       {loading ? (
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//           <CircularProgress />
//         </Box>
//       ) : error ? (
//         <Typography color="error" sx={{ textAlign: 'center' }}>
//           {error}
//         </Typography>
//       ) : (
//         <Box
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//             gap: '20px',
//             alignItems: 'stretch',
//           }}
//         >
//           {properties.slice(0, 4).map((property) => {
//             const isResidential = property.property_type === 'residential';
//             const isReadyToMove = property.construction_status === 'ready to move';
//             const propertyAmenities = getPropertyAmenities(property);
//             const hasImage = hasValidImage(property.image);
//             const displayPrice = getDisplayPrice(property);
//             const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
//             const timeAgo = getTimeAgo(property.createdAt);

//             return (
//               <Box
//                 key={property.id}
//                 sx={{
//                   width: '100%',
//                   display: 'flex',
//                   justifyContent: 'center',
//                 }}
//               >
//                 <Card
//                   sx={{
//                     width: { xs: '100%', sm: 360, md: '100%' },
//                     maxWidth: 350,
//                     height: '100%',
//                     backgroundColor: '#fff',
//                     borderRadius: '12px',
//                     boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//                     overflow: 'hidden',
//                     transition: 'transform 0.3s ease',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     '&:hover': {
//                       transform: 'translateY(-5px)',
//                     },
//                   }}
//                 >
//                   <Box sx={{ position: 'relative', width: '100%', height: 200, overflow: 'hidden' }}>
//                     {hasImage ? (
//                       <CardMedia
//                         component="img"
//                         image={`data:image/png;base64,${property.image}`}
//                         alt={property.property_name}
//                         sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                       />
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc'
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}

//                     {timeAgo && (
//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           top: '8px',
//                           right: '8px',
//                           bgcolor: 'rgba(0, 0, 0, 0.7)',
//                           color: '#fff',
//                           px: '8px',
//                           py: '4px',
//                           borderRadius: '4px',
//                           fontSize: '11px',
//                           fontWeight: 500,
//                           zIndex: 3,
//                         }}
//                       >
//                         {timeAgo}
//                       </Box>
//                     )}

//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         bottom: 0,
//                         left: 0,
//                         display: 'flex',
//                         width: '100%',
//                         height: '36px',
//                         zIndex: 2,
//                         lineHeight: 1,
//                         fontSize: '13px',
//                         fontWeight: 600,
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           backgroundColor: '#f7931e',
//                           color: '#fff',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           whiteSpace: 'nowrap',
//                           clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0% 100%)',
//                           padding: '3px 50px 6px 16px',
//                           marginRight: '-30px',
//                           height: '100%',
//                         }}
//                       >
//                         {isResidential ? 'Residential' : 'Commercial'}
//                       </Box>
//                       <Box
//                         sx={{
//                           backgroundColor: isReadyToMove ? '#00a885' : '#004b8d',
//                           color: '#fff',
//                           display: 'flex',
//                           alignItems: 'center',
//                                                     justifyContent: 'center',
//                           whiteSpace: 'nowrap',
//                           clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)',
//                           padding: isReadyToMove ? '3px 46px 6px 80px' : '6px 46px 6px 60px',
//                           height: '100%',
//                         }}
//                       >
//                         {isReadyToMove ? 'Ready to Move' : 'Under Construction'}
//                       </Box>
//                     </Box>
//                   </Box>

//                   <CardContent
//                     sx={{
//                       padding: '15px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '10px',
//                       flexGrow: 1,
//                       width: '90% !important',
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         gap: '10px',
//                         minHeight: '50px',
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: '18px',
//                           fontWeight: 600,
//                           color: '#000',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           display: '-webkit-box',
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: 'vertical',
//                           flex: 1,
//                         }}
//                       >
//                         {property.property_name}
//                       </Typography>

//                       <Typography
//                         sx={{
//                           fontSize: '14px',
//                           color: '#2563EB',
//                           fontWeight: 300,
//                           whiteSpace: 'nowrap',
//                           alignSelf: 'flex-start',
//                         }}
//                       >
//                         {displayPrice ? (
//                           <>
//                             ₹ {formatPrice(displayPrice)}
//                             {isRental && '/month'}
//                           </>
//                         ) : (
//                           'Price on Request'
//                         )}
//                       </Typography>
//                     </Box>

//                     <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#666', gap: '6px', minHeight: '24px' }}>
//                       <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
//                       <Typography
//                         sx={{
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap',
//                         }}
//                       >
//                         {property.location}, {property.area_name}
//                       </Typography>
//                     </Box>

//                     {propertyAmenities.length > 0 && (
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           width: '100%',
//                           minHeight: '70px',
//                           gap: '8px',
//                         }}
//                       >
//                         {propertyAmenities.map((amenity, idx) => (
//                           <Box
//                             key={idx}
//                             sx={{
//                               flex: 1,
//                               display: 'flex',
//                               flexDirection: 'column',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               gap: '6px',
//                             }}
//                           >
//                             <Box sx={{ color: '#666', fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                               {getAmenityIcon(amenity.type)}
//                             </Box>
//                             <Typography
//                               sx={{
//                                 fontSize: '13px',
//                                 color: '#444',
//                                 textAlign: 'center',
//                                 lineHeight: 1.2,
//                               }}
//                             >
//                               {amenity.value}
//                             </Typography>
//                           </Box>
//                         ))}
//                       </Box>
//                     )}

//                     <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 'auto', pt: '10px' }}>
//                       <Button
//                         component={Link}
//                         to={`/view/${property.id}`}
//                         variant="contained"
//                         onClick={() => handleViewProperty(property.id)}
//                         sx={{
//                           padding: '10px 44px',
//                           backgroundColor: '#005eff',
//                           color: 'white',
//                           borderRadius: '10px',
//                           cursor: 'pointer',
//                           fontWeight: 500,
//                           width: { xs: '100%', sm: 'fit-content' },
//                           '&:hover': {
//                             backgroundColor: '#004ecb',
//                           },
//                         }}
//                       >
//                         View Property
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Box>
//             );
//           })}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default FeaturedProperties;




import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTabContext } from './TabContext';

import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ApartmentIcon from '@mui/icons-material/Apartment';

const getAmenityIcon = (amenityType) => {
  const amenityIconMap = {
    'BHK': <BedIcon />,
    'Floor': <ApartmentIcon />,
    'Size': <SquareFootIcon />,
    'Bathroom': <BathtubIcon />
  };

  return amenityIconMap[amenityType] || <SquareFootIcon />;
};

const FeaturedProperties = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const { activeTab } = useTabContext();

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  const categoryMap = {
    'Buy': 'sale',
    'Rent': 'rent',
    'Plot': 'plot',
  };

  // Function to get user-friendly error message
  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    // Default generic message for any other error
    return 'Unable to load the properties. Please check your internet connection and try again.';
  };

  useEffect(() => {
    const fetchCommercialProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        const categoryType = categoryMap[activeTab];
        
        let url = 'https://www.propertydealstalk.com/api/property/filterProperties?property_type=commercial';
        
        if (activeTab === 'Plot') {
          url = 'https://www.propertydealstalk.com/api/property/filterProperties?property_type=commercial&asset_type=plot';
        } else if (categoryType) {
          url += `&category=${categoryType}`;
        }

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.statusCode === 200) {
          setProperties(data.result.properties);
        } else {
          throw new Error('Unable to load properties');
        }
      } catch (err) {
        const friendlyMessage = getUserFriendlyErrorMessage(err);
        setError(friendlyMessage);
        console.error('Error fetching properties:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCommercialProperties();
  }, [activeTab]);

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      return;
    }

    try {
      const userId = userData.id;
      if (!userId) {
        return;
      }

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();
      if (data.statusCode === 200) {
        console.log('Property view recorded successfully');
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';
    
    const priceStr = price.toString();
    const lastThree = priceStr.substring(priceStr.length - 3);
    const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    
    return lastThree;
  };

  const hasValidImage = (base64) => {
    return base64 && base64.length > 100;
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  const handleViewAllClick = () => {
    navigate('/featured-view');
  };

  const handleViewProperty = (propertyId) => {
    recordPropertyView(propertyId);
  };

  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  const getDisplayPrice = (property) => {
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    if (isValidValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null;
  };

  const getPropertyAmenities = (property) => {
    const amenities = [];

    if (isValidValue(property.bhk)) {
      amenities.push({ type: 'BHK', value: `${property.bhk} BHK` });
    }

    if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
      amenities.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
    }

    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push({ type: 'Size', value: `${property.property_size} ${sizeUnit}` });
    }

    return amenities;
  };

  const getSectionTitle = () => {
    switch (activeTab) {
      case 'Buy':
        return 'Commercial Property Deals for Sale';
      case 'Rent':
        return 'Commercial Property Deals for Rent';
      case 'Plot':
        return 'Commercial Plot Deals';
      default:
        return 'Commercial Property Deals';
    }
  };

  return (
    <Box
      id="featured-properties"
      sx={{
        backgroundColor: '#fff',
        padding: '0 20px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        marginTop: '30px',
        fontFamily: 'Outfit',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '20px 0',
          position: 'relative',
        }}
      >
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: '1.5rem',
              fontWeight: 600,
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'auto',
            }}
          >
            {getSectionTitle()}
          </Typography>
        </Box>
        <Button
          onClick={handleViewAllClick}
          variant="text"
          sx={{
            color: '#626262',
            fontSize: '0.8rem',
            fontWeight: 500,
            zIndex: 1,
            marginLeft: 'auto',
          }}
        >
          View All
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500,
              maxWidth: '600px'
            }}
          >
            {error}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(4, 1fr)',
            },
            gap: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
            justifyItems: 'center',
            alignItems: 'stretch',
          }}
        >
          {properties.slice(0, 4).map((property) => {
            const isResidential = property.property_type === 'residential';
            const isReadyToMove = property.construction_status === 'ready to move';
            const propertyAmenities = getPropertyAmenities(property);
            const hasImage = hasValidImage(property.image);
            const displayPrice = getDisplayPrice(property);
            const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
            const timeAgo = getTimeAgo(property.createdAt);

            return (
              <Card
                key={property.id}
                sx={{
                  width: '100%',
                  maxWidth: { xs: '100%', sm: 350, md: 350, lg: 350 },
                  height: '100%',
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                  },
                }}
              >
                <Box sx={{ position: 'relative', width: '100%', height: 200, overflow: 'hidden' }}>
                  {hasImage ? (
                    <CardMedia
                      component="img"
                      image={`data:image/png;base64,${property.image}`}
                      alt={property.property_name}
                      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5',
                        border: '1px dashed #ccc'
                      }}
                    >
                      <Typography variant="body2" color="#888" textAlign="center" px={2}>
                        No images uploaded
                      </Typography>
                    </Box>
                  )}

                  {timeAgo && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                        color: '#fff',
                        px: '8px',
                        py: '4px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 500,
                        zIndex: 3,
                      }}
                    >
                      {timeAgo}
                    </Box>
                  )}

                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      display: 'flex',
                      width: '100%',
                      height: '36px',
                      zIndex: 2,
                      lineHeight: 1,
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#f7931e',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        whiteSpace: 'nowrap',
                        clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0% 100%)',
                        padding: '3px 50px 6px 16px',
                        marginRight: '-30px',
                        height: '100%',
                      }}
                    >
                      {isResidential ? 'Residential' : 'Commercial'}
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: isReadyToMove ? '#00a885' : '#004b8d',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        whiteSpace: 'nowrap',
                        clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)',
                        padding: isReadyToMove ? '3px 46px 6px 80px' : '6px 46px 6px 60px',
                        height: '100%',
                      }}
                    >
                      {isReadyToMove ? 'Ready to Move' : 'Under Construction'}
                    </Box>
                  </Box>
                </Box>

                <CardContent
                  sx={{
                    padding: '15px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    flexGrow: 1,
                    width: '90% !important',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      gap: '10px',
                      minHeight: '50px',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '18px',
                        fontWeight: 600,
                        color: '#000',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        flex: 1,
                      }}
                    >
                      {property.property_name}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: '#2563EB',
                        fontWeight: 300,
                        whiteSpace: 'nowrap',
                        alignSelf: 'flex-start',
                      }}
                    >
                      {displayPrice ? (
                        <>
                          ₹ {formatPrice(displayPrice)}
                          {isRental && '/month'}
                        </>
                      ) : (
                        'Price on Request'
                      )}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#666', gap: '6px', minHeight: '24px' }}>
                    <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
                    <Typography
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {property.location}, {property.area_name}
                    </Typography>
                  </Box>

                  {propertyAmenities.length > 0 && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        minHeight: '70px',
                        gap: '8px',
                      }}
                    >
                      {propertyAmenities.map((amenity, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                          }}
                        >
                          <Box sx={{ color: '#666', fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {getAmenityIcon(amenity.type)}
                          </Box>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              color: '#444',
                              textAlign: 'center',
                              lineHeight: 1.2,
                            }}
                          >
                            {amenity.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}

                  <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 'auto', pt: '10px' }}>
                    <Button
                      component={Link}
                      to={`/view/${property.id}`}
                      variant="contained"
                      onClick={() => handleViewProperty(property.id)}
                      sx={{
                        padding: '10px 44px',
                        backgroundColor: '#005eff',
                        color: 'white',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        fontWeight: 500,
                        width: { xs: '100%', sm: 'fit-content' },
                        '&:hover': {
                          backgroundColor: '#004ecb',
                        },
                      }}
                    >
                      View Property
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default FeaturedProperties;
